@if(currentURL == 'ep-overview' || currentURL1 == 'inbox' || currentURL1 == 'news-feeds' ||currentURL == 'booking-calendar' || currentURL == 'ep-profile' || currentURL == 'your-profile' || currentURL1 == 'experience-settings' || currentURL1 == 'edit-experience' || currentURL == 'your-profile' || currentURL1 == 'experience-availability' || currentURL == 'exp-booking' ){
    <div class="epdash-subheader" id="epdash-subheader">
        <div class="container">
            <nav class="navbar navbar-expand-lg">
                <!-- <div class="epdash-menu-toggle d-lg-none" id="epdash-menu-toggle">
                    Menu
                    <i class="fas fa-long-arrow-down"></i>
                </div> -->
                <div class="navbar-collapse" id="epdash-menu-toggleNav" hidden>
                    <!-- <ul class="navbar-nav ">
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                            <a class="nav-link" [routerLink]="['/ep-overview']" *ngIf="authUser?.role_id == '2' && currentURL1 == 'edit-experience'">RETURN TO DASHBOARD</a>
                        </li>
                    </ul> -->
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}" [ngClass]="{'activeLinkFriends':(currentURL1 == 'ep-overview' )}">
                            @if(authUser?.role_id=='2'){
                                <a href="javascript:void(0);" class="nav-link" [routerLink]="['/ep-overview']">OVERVIEW</a>
                            }
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}" [ngClass]="{'activeLinkFriends':(currentURL1 == 'edit-experience' )}">
                            @if(authUser?.role_id=='2'){
                                <a href="javascript:void(0);" class="nav-link" [routerLink]="['/ep-profile']">
                                    EXPERIENCES
                                </a>
                            }
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                            @if(authUser?.role_id=='2'){
                                <a href="javascript:void(0);" class="nav-link" [routerLink]="['/inbox']">INBOX</a>
                            }
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                            @if(authUser?.role_id=='2'){
                                <a href="javascript:void(0);" class="nav-link" [routerLink]="['/news-feeds']">NEWS FEED</a>
                            }
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                            @if(authUser?.role_id=='2'){
                            <a href="javascript:void(0);" class="nav-link" [routerLink]="['/booking-calendar']">CALENDAR</a>
                            }
                        </li>
                        <!-- @if(authUser && authUser?.provider_booking_type > 0 && authUser?.booking_count > 0 && authUser?.role_id=='2'){
                            <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                                <a href="javascript:void(0);" class="nav-link" [routerLink]="['/exp-booking']"> BOOKING</a>
                            </li>
                        } -->
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                            <a href="javascript:void(0);" class="nav-link" [routerLink]="['/your-profile/experience-provider']"> PAYMENTS</a>
                        </li>
                        <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:false}">
                            @if(authUser?.role_id=='2'){
                                <a href="javascript:void(0);" class="nav-link" [routerLink]="['/experience-settings']"> SETTINGS</a>
                            }
                        </li>
                        @if(authUser && authUser.provider_booking_type == 1 && authUser?.role_id=='2'){
                            <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                                <a href="javascript:void(0);" class="nav-link" [routerLink]="['/experience-availability']"> AVAILABILITY</a>
                            </li>
                        }
                        <!-- @if(authUser && authUser.provider_booking_type != 1 && authUser?.role_id=='2'){
                            <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}"  [ngClass]="{'activeLinkFriends':(currentURL1 == 'experience-availability' )}">
                                <a href="javascript:void(0);" class="nav-link" [routerLink]="['/experience-availability']"> PROMOTIONAL PRICING</a>
                            </li>
                        } -->
                    </ul>
                </div>
            </nav>
        </div>
    </div>
}
